export default __webpack_public_path__ + "0c9b6886b41c6da1b239a632fc43acfb.svg";